import { useLocation } from 'react-router-dom';

const BASE_URL = 'https://glassexpertsingapore.com';
const DEFAULT_OG_IMAGE =
  'https://readdy.ai/api/search-image?query=Modern%20luxury%20glass%20building%20exterior%20facade%20with%20reflective%20panels%20blue%20sky%20warm%20neutral%20architectural%20photography%20wide%20shot%20clean%20minimal%20professional&width=800&height=420&seq=og-default-1&orientation=landscape';

interface SEOHeadProps {
  title: string;
  description: string;
  keywords?: string;
  type?: string;
  ogImage?: string;
  twitterImage?: string;
  canonical?: string;
  noindex?: boolean;
  lastModified?: string;
  structuredData?: Record<string, unknown> | Record<string, unknown>[];
}

export default function SEOHead({
  title,
  description,
  keywords,
  type = 'website',
  ogImage,
  twitterImage,
  canonical,
  noindex = false,
  lastModified,
  structuredData,
}: SEOHeadProps) {
  const location = useLocation();
  const pathname = location.pathname;
  const canonicalUrl = canonical || `${BASE_URL}${pathname}`;
  const ogUrl = `${BASE_URL}${pathname}`;
  const modified = lastModified || new Date().toISOString().split('T')[0];
  const image = ogImage || DEFAULT_OG_IMAGE;
  const twImage = twitterImage || image;

  const renderSchema = () => {
    if (!structuredData) return null;
    const schemas = Array.isArray(structuredData) ? structuredData : [structuredData];
    return schemas.map((data, i) => (
      <script
        key={i}
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
      />
    ));
  };

  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={ogUrl} />
      <meta property="og:image" content={image} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={twImage} />
      <link rel="canonical" href={canonicalUrl} />
      <meta name="last-modified" content={modified} />
      {noindex && <meta name="robots" content="noindex, follow" />}
      {renderSchema()}
    </>
  );
}